// Used to validate a coupon token received from a marketing link
export const CouponService_GetUnlockCouponInfoLazy = () =>
  import("./service.grpc").then((m) => m.CouponService_GetUnlockCouponInfo);
CouponService_GetUnlockCouponInfoLazy.method =
  "aysa_api.services.coupons.v1.CouponService/GetUnlockCouponInfo" as const;

// Gets a high tier coupon banner
export const CouponService_GetHighTierCouponBannerLazy = () =>
  import("./service.grpc").then((m) => m.CouponService_GetHighTierCouponBanner);
CouponService_GetHighTierCouponBannerLazy.method =
  "aysa_api.services.coupons.v1.CouponService/GetHighTierCouponBanner" as const;
